var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62752 21.4985L9.6 13.6235H6V10.2485H9.6V7.99854C9.6 4.96194 11.6058 3.49854 14.4953 3.49854C15.8793 3.49854 17.0689 3.59514 17.4155 3.63832V6.81174L15.4116 6.81259C13.8401 6.81259 13.5358 7.51265 13.5358 8.53993V10.2485H18L16.8 13.6235H13.5358V21.4985H9.62752Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.f7cb0780eaee65a1493db18646c1567b.svg";
export { ForwardRef as ReactComponent };